import * as React from 'react';

interface CenteredImageProps {
    className: string;
    src?: string | null;
    cover?: boolean;
}

interface CenteredImageState {
    loaded: boolean;
    error: boolean;
}

export class CenteredImage extends React.Component<CenteredImageProps, CenteredImageState> {
    public componentWillMount(): void {
        this.setState({
            loaded: !this.props.cover,
            error: false
        });
    }

    public render(): JSX.Element {
        let img: JSX.Element | null = null;
        let backgroundLoad: JSX.Element | null = null;
        const imgStyle: React.CSSProperties = {};
        if (!this.state.loaded) {
            imgStyle.display = 'none';
        }

        const cssStyle: React.CSSProperties = {};
        if (!this.props.className) {
            cssStyle.height = '100%';
        }

        if (this.props.src != null) {
            if (this.props.cover) {
                backgroundLoad = (
                    <img
                        style={{display: 'none'}}
                        src={this.props.src}
                        onLoad={this.onLoad}
                        onError={this.onError}
                    />
                );
            }

            if (this.state.loaded) {
                if (this.props.cover) {
                    img = <div className="cover-image" style={{backgroundImage: 'url(\'' + this.props.src + '\')'}}/>;
                } else {
                    img = <img src={this.props.src}/>;
                }
            }
        }

        return (
            <div className={this.props.className + ' centered-image'} style={cssStyle}>
                <span className="img-helper"/>
                {img}
                {this.state.loaded ? null : <div className="image-placeholder"/>}
                {backgroundLoad}
            </div>
        );
    }

    protected onLoad = () => {
        this.setState({loaded: true, error: false});
    };

    protected onError = () => {
        this.setState({loaded: true, error: true});
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CenteredImage.tsx